export default __webpack_public_path__ + "static/media/logoDgartes.7654b406.png";